/**
 * Atenua o mapa-base carregado em runtime (VIEWER_MAP_STYLE_URL): ele deve permanecer
 * contexto, sem competir visualmente com o relevo e as camadas territoriais/da Geo-Engine.
 * Usa apenas capacidades nativas do style do MapLibre — nenhum controle novo de UI.
 */
export const FATOR_DE_OPACIDADE_DO_BASEMAP = 0.72;
const PROPRIEDADE_DE_OPACIDADE = {
    fill: 'fill-opacity',
    line: 'line-opacity',
    raster: 'raster-opacity',
    background: 'background-opacity',
};
/**
 * Remove rótulos/POIs do mapa-base (competem com a leitura territorial) e reduz a opacidade
 * das demais camadas de fundo. Roda uma única vez, ao carregar o estilo.
 */
export function subordinarBasemap(mapa) {
    const camadas = mapa.getStyle()?.layers ?? [];
    for (const camada of camadas) {
        if (camada.type === 'symbol') {
            mapa.setLayoutProperty(camada.id, 'visibility', 'none');
            continue;
        }
        const propriedade = PROPRIEDADE_DE_OPACIDADE[camada.type];
        if (propriedade === undefined) {
            continue;
        }
        const atual = mapa.getPaintProperty(camada.id, propriedade);
        const base = typeof atual === 'number' ? atual : 1;
        mapa.setPaintProperty(camada.id, propriedade, base * FATOR_DE_OPACIDADE_DO_BASEMAP);
    }
}
